import * as C from "./constants";
import { Platform } from "./types";

export interface OutlineSegment {
  x: number;
  y: number;
  width: number;
  height: number;
}

function findConnectedPlatforms(platforms: Platform[]): Platform[][] {
  const visited = new Set<number>();
  const groups: Platform[][] = [];

  for (const [index, _] of platforms.entries()) {
    if (visited.has(index)) {
      continue;
    }

    const group: Platform[] = [];
    const stack = [index];

    while (stack.length > 0) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const currentIndex = stack.pop()!;
      if (visited.has(currentIndex)) {
        continue;
      }

      visited.add(currentIndex);
      const current = platforms[currentIndex];
      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      group.push(current);

      for (const [otherIndex, other] of platforms.entries()) {
        if (visited.has(otherIndex)) {
          continue;
        }

        const horizontallyAdjacent =
          // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
          current.y < other.y + other.height &&
          // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
          current.y + current.height > other.y &&
          // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
          (current.x + current.width === other.x ||
            // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
            other.x + other.width === current.x);

        const verticallyAdjacent =
          // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
          current.x < other.x + other.width &&
          // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
          current.x + current.width > other.x &&
          // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
          (current.y + current.height === other.y ||
            // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
            other.y + other.height === current.y);

        if (horizontallyAdjacent || verticallyAdjacent) {
          stack.push(otherIndex);
        }
      }
    }

    groups.push(group);
  }

  return groups;
}

function traceGroupOutlines(group: Platform[]): OutlineSegment[] {
  if (group.length === 0) {
    return [];
  }

  const outlineSegments: OutlineSegment[] = [];

  const minX = Math.min(...group.map((p) => p.x));
  const maxX = Math.max(...group.map((p) => p.x + p.width));
  const minY = Math.min(...group.map((p) => p.y));
  const maxY = Math.max(...group.map((p) => p.y + p.height));

  const gridWidth = maxX - minX;
  const gridHeight = maxY - minY;
  const grid: boolean[][] = [];

  for (let x = 0; x < gridWidth; x++) {
    grid[x] = [];
    for (let y = 0; y < gridHeight; y++) {
      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      grid[x][y] = false;
    }
  }

  for (const platform of group) {
    for (let x = platform.x; x < platform.x + platform.width; x++) {
      for (let y = platform.y; y < platform.y + platform.height; y++) {
        const gridX = x - minX;
        const gridY = y - minY;
        if (
          gridX >= 0 &&
          gridX < gridWidth &&
          gridY >= 0 &&
          gridY < gridHeight
        ) {
          // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
          grid[gridX][gridY] = true;
        }
      }
    }
  }

  const outlineThickness = C.OUTLINE_THICKNESS;

  for (let x = 0; x < gridWidth; x++) {
    for (let y = 0; y < gridHeight; y++) {
      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      if (!grid[x][y]) {
        continue;
      }

      const worldX = x + minX;
      const worldY = y + minY;

      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      if (y === gridHeight - 1 || !grid[x][y + 1]) {
        outlineSegments.push({
          x: worldX,
          y: worldY + 1,
          width: 1,
          height: outlineThickness,
        });
      }

      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      if (y === 0 || !grid[x][y - 1]) {
        outlineSegments.push({
          x: worldX,
          y: worldY - outlineThickness,
          width: 1,
          height: outlineThickness,
        });
      }

      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      if (x === 0 || !grid[x - 1][y]) {
        outlineSegments.push({
          x: worldX - outlineThickness,
          y: worldY,
          width: outlineThickness,
          height: 1,
        });
      }

      // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
      if (x === gridWidth - 1 || !grid[x + 1][y]) {
        outlineSegments.push({
          x: worldX + 1,
          y: worldY,
          width: outlineThickness,
          height: 1,
        });
      }
    }
  }

  return outlineSegments;
}

export function generatePlatformOutlines(
  platforms: Platform[],
): OutlineSegment[] {
  const groups = findConnectedPlatforms(platforms);
  return groups.flatMap((group) => traceGroupOutlines(group));
}
